import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TypeWritterLoader from "./TypeWritterLoader";
import { POSchema } from "./info-templates-schema/purchaseOrderDetailSchema";
import { impexDateFormat } from "../manager/dateManager";
import ColouredChip from "./ColouredChip";
import { getUser } from "../services/authService";
import {
  downlaodPoDocument,
  getPurchaseOrderlineItemsByPOID,
} from "../services/dataService";
import { PO_PART_DETAILS } from "../columns/columns";
import BasicTable from "./table/BasicTable";
import {
  poStatusHandler,
  PO_ACCEPTED,
  PO_NEW,
  PO_UPDATED,
  PO_VIEWED,
} from "../manager/actionManager";
import CommentBox from "./CommentBox";
import { useParams } from "react-router-dom";

function PurcchseOrderActionModal({ handleClose, purchaseOrderID }) {
  const { POID } = useParams();
  const [po, setPO] = useState(null);
  const [error, setError] = useState(false);
  const [loader, setLoader] = useState(false);
  const user = getUser();
  const [poDetailInfo, setPODetailInfo] = useState([]);
  const [poDocument, setPODocument] = useState("");

  useEffect(() => {
    setError(false);
    async function getPODcoumnt(docPoId) {
      try {
        const response = await downlaodPoDocument(purchaseOrderID);
        setPODocument(response.data);
      } catch (error) {}
    }
    async function getPODetails(poId) {
      try {
        const infoResponse = await getPurchaseOrderlineItemsByPOID(
          purchaseOrderID
        );
        setPO(infoResponse.data[0]);
        setPODetailInfo(infoResponse.data);
      } catch (error) {
        setPODetailInfo([]);
        setError(true);
      }
    }
    if (purchaseOrderID) {
      setLoader(true);
      getPODcoumnt(purchaseOrderID);
      getPODetails(purchaseOrderID);
      setLoader(false);
    }
    return () => {
      setPO(null);
      setPODocument("");
      setPODetailInfo([]);
      setError(false);
    };
  }, [purchaseOrderID, POID]);

  const canLoad = () => {
    if (user?.isSupplierOperation || user?.isSupplierAdmin) {
      if ([PO_NEW, PO_VIEWED, PO_UPDATED].includes(po?.LatestAction)) {
        return true;
      } else return false;
    } else return false;
  };

  const getPopUpSize = () => {
    if (loader) return "sm";
    if (!loader) return "lg";
    else return "lg";
  };


  return (
    <>
      <Dialog
        fullWidth
        maxWidth={getPopUpSize()}
        open={Boolean(purchaseOrderID)}
        onClose={handleClose}
      >
        <DialogTitle sx={{ ml: 3 }}>
          {"Purchase Order Details"}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {po ? (
          <DialogContent>
            {loader && <TypeWritterLoader status={error} />}
            {!loader && (
              <Grid container>
                <Grid
                  item
                  lg={8}
                  md={6}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                  }}
                >
                  {poDocument ? (
                    <iframe
                      src={poDocument}
                      title="invoice"
                      style={{
                        minWidth: "730px",
                        minHeight: "820px",
                        border: "none",
                        borderRadius: "4px",
                      }}
                      allowFullScreen
                    />
                  ) : (
                    <TypeWritterLoader status={false} />
                  )}
                </Grid>
                <Grid item lg={4}>
                  <Typography omponent="h2" marginBottom={2} variant="h4">
                    {po ? `#${po.PONumber}` : " "}
                  </Typography>
                  <TableContainer
                    component={Paper}
                    sx={{
                      mb: "20px",
                    }}
                  >
                    <Table
                      sx={{
                        borderCollapse: "separate",
                      }}
                    >
                      <TableBody>
                        {POSchema.map((item) => (
                          <TableRow key={item.valueKey}>
                            <TableCell
                              component="th"
                              scope="row"
                              sx={{
                                width: "140px !important",
                              }}
                            >
                              {item.nameKey}
                            </TableCell>
                            {item.valueKey !== "DueDate" ? (
                              <TableCell align="left">
                                {po[item.valueKey]}
                              </TableCell>
                            ) : (
                              <TableCell align="left">
                                <ColouredChip
                                  label={impexDateFormat(po[item.valueKey])}
                                  type="red"
                                  fontSize="10"
                                />
                              </TableCell>
                            )}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <BasicTable columns={PO_PART_DETAILS} data={poDetailInfo} />
                  {canLoad() && (
                    <>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                          mb: 1,
                          fontSize: "12px",
                        }}
                        onClick={() => {
                          poStatusHandler(po, PO_ACCEPTED, poDetailInfo);
                          setPO({
                            ...po,
                            LatestAction: PO_ACCEPTED,
                          });
                          handleClose();
                        }}
                        disabled={
                          po.LatestAction === PO_ACCEPTED || !poDocument
                        }
                      >
                        Accept
                      </Button>
                    </>
                  )}

                  <CommentBox POID={purchaseOrderID} FormName={"PO"} />
                </Grid>
              </Grid>
            )}
          </DialogContent>
        ) : (
          <TypeWritterLoader status={error} />
        )}
        <DialogActions>
          <Button
            onClick={handleClose}
            sx={{
              fontSize: "12px",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default PurcchseOrderActionModal;
